import IQueries from '@/interfaces/IQueries';

// Path with parameters
const masterServer: IQueries = {
    master_server_history: {
        path: '/vpn/master_host_change_logs',
        method: 'GET'
    },
    master_server_create: {
        path: '/vpn/master_host_change_logs',
        method: 'POST'
    }
};

export default masterServer;